import {Component, OnInit} from '@angular/core';
import {ReportMainComponent} from './components/report-main/report-main.component';
import {TopViewComponent} from './components/top-view/top-view.component';
import {PageScrollConfig} from 'ng2-page-scroll';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    ReportMainComponent,
    TopViewComponent
  ],
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor() {
    PageScrollConfig.defaultScrollOffset = 50;
    PageScrollConfig.defaultEasingLogic = {
      ease: (t: number, b: number, c: number, d: number): number => {
        if (t === 0) return b;
        if (t === d) return b + c;
        if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
        return c / 2 * (-Math.pow(2, -10 * (t - 1)) + 2) + b;
      },
    };
  }

  ngOnInit() {
    // Always show the nav search bar
    document.getElementsByTagName('body')[0].classList.add('top-search-visible');
  }

  public hideNavigation() {
    document.getElementsByTagName('body')[0].classList.remove('menu-hidden');
  }
}
